import { IController } from 'angular';
import * as _ from 'lodash';

import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { Cohort } from '../../../../../../../ng2/shared/constants/cohort.constant';
import { GraduationPlanTransfer } from '../../../../../../../ng2/shared/constants/graduation-plan-transfer.constant';
// tslint:disable-next-line:max-line-length
import { GraduationPlanWarnings as Warnings } from '../../../../../../../ng2/shared/constants/graduation-plan-warnings.constant';
import { GraduationPlanWarningsCreditAndRegentsThresholds as WarningThresholds } from '../../../../../../../ng2/shared/constants/graduation-plan-warnings.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class OffTrackCtrl implements IController {
  static $inject: string[] = ['$scope', 'ImSchool', 'WizardUtils'];

  private school;
  private nextGradDate;
  public explainer;
  public filteredStudents;
  public gradWarnings;
  public totalWithWarning;
  public nextFourGradDates;
  public studentsGraduatingInNext4Terms;
  public creditThresholdForWarning;
  public regentsThresholdForWarning;
  public filterOptions;
  public studentIdsGraduatingInNext4Terms;

  constructor(public $scope, private ImSchool: ImSchool, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi() {
    this.filterOptions = { columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'] };
    this.school = this.WizardUtils.getCurrentSdcSchool();
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.gradWarnings = this.getStudentIdsByGradWarnings();
    this.totalWithWarning = this.gradWarnings.withWarning;
    this.nextGradDate = this.ImSchool.getNextFourGradDatesForTransfer()[3];
    this.nextFourGradDates = this.ImSchool.getNextFourGradDatesForTransfer();
    this.studentsGraduatingInNext4Terms = this.getStudentsGraduatingInNext4Terms();
    this.studentIdsGraduatingInNext4Terms = _.map(this.studentsGraduatingInNext4Terms, ({ studentId }) => studentId);
    this.explainer = this.ImSchool.getDistanceToGradMetricsExplainer(this.school, this.nextGradDate.humanName);
    const filter = this.WizardUtils.getEntireSdcFilter();
    const cohortFilter: string = filter && filter.cohort && _.last(filter.cohort);
    const cohortDetails = _.find(Cohort, { humanName: cohortFilter });
    const studentYear = !cohortFilter ? 4 : cohortDetails.studentYear > 4 ? 4 : cohortDetails.studentYear;
    this.creditThresholdForWarning = WarningThresholds[studentYear].lessThanCredits;
    this.regentsThresholdForWarning = WarningThresholds[studentYear].lessThanRegents;
  }

  private getStudentsGraduatingInNext4Terms() {
    const nextFourGradDates = _.map(this.nextFourGradDates, (gradDate: any) => gradDate.humanName);
    return _.filter(this.filteredStudents, (student: any) => {
      const gradPlan: any = _.find(GraduationPlanTransfer, { humanName: student.gradPlan });
      if (!gradPlan) return;
      if (gradPlan.diploma && _.includes(nextFourGradDates, gradPlan.date)) return student;
    });
  }

  private getIncompletePlans() {
    return _.reduce(
      this.filteredStudents,
      (result, student: any) => {
        const hasPlanIncompleteWarning = _.includes(student.gradPlanWarnings, Warnings.incompleteGradPlan);
        if (hasPlanIncompleteWarning) result.push(student.studentId);
        return result;
      },
      [],
    );
  }

  private getStudentIdsByGradWarnings() {
    const buckets = {
      withWarning: [],
      lessThan65Attendance: [],
      lessThanCreditsRegentsCheck: [],
      ageOut: [],
      planIncomplete: [],
      localEligiblePlannedForRegents: [],
    };
    const plannedGraduates = this.getStudentsGraduatingInNext4Terms();
    _.each(plannedGraduates, (student: any) => {
      const { studentId, gradPlanWarnings } = student;
      if (!gradPlanWarnings) return;
      if (gradPlanWarnings.length >= 1) buckets.withWarning.push(studentId);
      _.each(gradPlanWarnings, warning => {
        if (warning === Warnings.lessThan65AttendanceLastYear) buckets.lessThan65Attendance.push(studentId);
        if (warning === Warnings.lessThanCreditsRegentsCheck) buckets.lessThanCreditsRegentsCheck.push(studentId);
        if (warning === Warnings.ageOut) buckets.ageOut.push(studentId);
        if (warning === Warnings.localEligiblePlannedForRegents) buckets.localEligiblePlannedForRegents.push(studentId);
      });
    });

    buckets.planIncomplete = this.getIncompletePlans();
    buckets.withWarning = buckets.withWarning.concat(buckets.planIncomplete);

    return buckets;
  }
}
